import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => (
  <Box
    sx={{
      height: '40px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      p: '0 20px',
    }}
  >
    <Box sx={{ fontSize: '14px', fontWeight: 400, color: '#000000' }}>
      Copyright © {new Date().getFullYear()} SafalVir, Inc. All Rights Reserved{' '}
      <span style={{ fontWeight: 'bold', color: 'red' }}>Development Server</span>
      <span className="display-version">{process.env.REACT_APP_VERSION}</span>
    </Box>
    <Box sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px', lg: '16px' }, fontWeight: 400, color: '#000000' }}>
      <Link to="/term-and-condition">Terms & Condition</Link> | <Link to="/privacy-policy">Privacy Policy</Link>
    </Box>
  </Box>
);

export default Footer;
